export const gridQuestionsLayoutWith3InLastRow = ['question_6', 'question_9'];
export const gridQuestionsLayoutWith2InLastRow = [
  'question_2',
  'question_4',
  'question_7',
  'question_8',
  'question_10',
];
